import React from 'react';
import { Alert, List, Modal, Space, Tag, Typography } from 'antd';
const { Text } = Typography;
const GroupPaymentStatusModal = ({ isVisible, onClose, groupPaymentStatus, loading }) => {
    return (
        <Modal
            visible={isVisible}
            title="Group Members Payment Status"
            onCancel={onClose}
            footer={null}
            loading={loading}
        >
            <Space direction='vertical' style={{ width: '100%' }}>
                <Text>Please view the payment status of your group members below:</Text>
                <List>
                    {groupPaymentStatus.map((status, index) => (
                        <List.Item key={index}>
                            <List.Item.Meta title={status.member} description={<Tag color={status.paid ? "green" : "red"}>{status.paid ? "Paid" : "Not Paid"}</Tag>}/>
                        </List.Item>
                    ))}
                </List>
                <Alert showIcon message="Please note your group's events will not be registered until all members have made their payment."/>
            </Space>
        </Modal>
    );
};

export default GroupPaymentStatusModal;  
